import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import { useWorkflowEventQuery } from '@dashboard/generated/wp/platform';
import { useWorkflowRunShowHref } from '@dashboard/hooks/route/hrefs';
import { OpenInNewOutlined } from '@mui/icons-material';
import { Alert, CircularProgress } from '@mui/material';

type Props = {
  workflowRunId: string | null;
};

export default function PreviewWorkflowRun({ workflowRunId }: Props) {
  const { data, loading } = useWorkflowEventQuery({
    variables: { id: workflowRunId ?? '' },
    pollInterval: 3000,
    skip: workflowRunId === null,
  });

  if (workflowRunId === null) {
    return null;
  }

  const event = data?.WorkflowEvent;
  if (loading || !event) {
    return (
      <Alert
        variant="outlined"
        severity="info"
        iconMapping={{
          info: <CircularProgress size={16} />,
        }}
        sx={{ mt: 3, color: 'text.primary' }}
      >
        Processing workflow &hellip;
      </Alert>
    );
  }
  return (
    <Alert
      variant="outlined"
      severity="success"
      sx={{ mt: 3, color: 'text.primary', alignItems: 'center' }}
      action={<WorkflowRunLink id={event.id} />}
    >
      Workflow test run completed
    </Alert>
  );
}

function WorkflowRunLink({ id }: { id: string }) {
  const href = useWorkflowRunShowHref({ id });
  return (
    <Link
      href={href}
      target="_blank"
      fontWeight="fontWeightMedium"
      sx={{ color: 'inherit', display: 'flex', gap: 1, alignItems: 'center' }}
    >
      View details
      <OpenInNewOutlined sx={{ fontSize: 14 }} />
    </Link>
  );
}
